import { render } from "./ProductRecommanded.vue?vue&type=template&id=03fca9d0&scoped=true"
import script from "./ProductRecommanded.vue?vue&type=script&lang=js"
export * from "./ProductRecommanded.vue?vue&type=script&lang=js"

import "./ProductRecommanded.vue?vue&type=style&index=0&id=03fca9d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03fca9d0"]])

export default __exports__